import { useMemo } from "react";
import "./Status.scss";
import { Icon } from "../Icon";

import cx from "classnames";

type StatusProps = {
  size?: "default" | "lg" | "label" | "lg-label";
  label: string;
  iconName?: string;
  color?: string;
  className?: string;
  disabled?: boolean;
};

const Status = ({
  label,
  iconName = "PlaceholderPing",
  color,
  className,
  size = "default",
  disabled = false,
}: StatusProps) => {
  const iconSize = useMemo(() => {
    if (size === "lg" || size === "lg-label") {
      return 16;
    }
    return 12;
  }, [size]);

  const iconComponent = useMemo(() => {
    if (iconName === "VisionLoader") {
      return (
        <Icon
          iconName="LoaderCircle"
          width={iconSize}
          height={iconSize}
          className="Status__Loader"
          style={color ? { color } : undefined}
        />
      );
    }
    return (
      <Icon
        iconName={iconName as any}
        width={iconSize}
        height={iconSize}
        className="Status__Dot"
        style={color ? { color } : undefined}
      />
    );
  }, [iconName, iconSize, color]);

  return (
    <div
      className={cx(
        "Status",
        {
          "Status--Large": size === "lg",
          "Status--Label": size === "label",
          "Status--LgLabel": size === "lg-label",
        },
        className,
        { "Status--Disabled": disabled },
      )}
    >
      {iconComponent}
      {label}
    </div>
  );
};

export { Status };
